import { boolean, defineAction, enumerated, object, string } from '~/prix'
import monitorProductMetricImportAction from './monitorProductMetricImport.action.json'

const monitorProductMetricImportDefinition = defineAction({
  ...monitorProductMetricImportAction,
  input: object({
    file: string().isOptional(),
    step: enumerated({
      fetchUploadUrl: 'fetchUploadUrl',
      importFile: 'importFile',
    }),
    contentType: string().isOptional(),
  }),
  output: object({
    success: boolean(),
  }),
})

export default monitorProductMetricImportDefinition
